export const useReviewParameters = () => {
	if (!import.meta.client) return;

	const route = useRoute();
	const { setReviewIds } = useReviewIds();

	watch(
		() => route.query,
		async () => {
			const { reviewIds } = route.query as { reviewIds: string };

			if (!reviewIds) return;

			try {
				if (!reviewIds) {
					setReviewIds([]);
					return;
				}

				setReviewIds(reviewIds.split(","));
			} catch (error) {
				console.error("something went wrong while setting the review ids", error);
				return;
			}
		},
		{
			immediate: true
		}
	);
};
